<template>
    <div class="page-table mainDiv haberTanim" id="affix-container">
        <div class="animated fadeInUp card-base baslikBg">{{$t("src.views.apps.popup.guncelle.baslikH1")}}</div>
        <el-row :gutter="10">
            <el-form status-icon :model="popupForm" :rules="rulesPopup" ref="popupForm"
                     class="demo-ruleForm">
                <el-col :lg="18" :md="18" :sm="24" :xs="24">
                    <div class="card-base card-shadow--medium demo-box bg-white animated fadeInLeft">
                        <div>
                            <el-row>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.baslik")'
                                                  prop="baslik">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="popupForm.baslik"
                                                  :placeholder='$t("src.views.apps.popup.tanimlama.baslikPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.link")'
                                                  prop="link">:
                                        <el-input v-on:change="$store.commit('changeTabsClose', false)"
                                                  v-model="popupForm.link"
                                                  :placeholder='$t("src.views.apps.popup.tanimlama.linkPlace")'></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="12" :md="12" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.tarih")'
                                                  prop="tarih">:
                                        <el-date-picker
                                                v-on:change="changeTarih"
                                                style="width: 100%"
                                                v-model="popupForm.tarih"
                                                type="datetimerange"
                                                start-placeholder="Başlama Tarihi"
                                                end-placeholder="Bitiş Tarihi"
                                                format="yyyy-MM-dd HH:mm:ss"
                                                value-format="yyyy-MM-dd HH:mm:ss"
                                                :default-time="['08:00:00', '17:00:00']">
                                        </el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                    <el-form-item :label='$t("src.views.apps.popup.tanimlama.icerik")'
                                                  prop="icerik">:
                                        <ckeditor @blur="$store.commit('changeTabsClose', false)" :editor="editor"
                                                  :config="editorConfig"
                                                  v-model="popupForm.icerik"></ckeditor>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <el-collapse style="margin-top: 10px" v-model="activeCollapse">
                        <el-row>
                            <el-col :span="24">
                                <draggable
                                        data-source="juju"
                                        class="list-group"
                                        group="a">
                                    <el-collapse-item class="card-shadow--medium" title="Resim Ayarları" name="4">
                                        <el-row>
                                            <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                                <el-form-item
                                                        :label='$t("src.views.apps.popup.tanimlama.resim")'
                                                        prop="image">:
                                                    <el-upload
                                                            action=""
                                                            :auto-upload="false"
                                                            :limit="1"
                                                            :file-list="imageMain"
                                                            accept=".jpg,.jpeg,.png"
                                                            ref="upload"
                                                            list-type="picture-card"
                                                            :on-change="imageUpload"
                                                            :on-remove="imageRemove">
                                                        <i slot="default" class="el-icon-plus"></i>
                                                    </el-upload>
                                                </el-form-item>
                                            </el-col>
                                        </el-row>
                                    </el-collapse-item>
                                </draggable>
                            </el-col>
                        </el-row>
                    </el-collapse>
                </el-col>
                <el-col :lg="6" :md="6" :sm="24" :xs="24">
                    <el-collapse class="yanForm animated fadeInUp" v-model="activeCollapse">
                        <el-collapse-item class="card-shadow--medium" name="1"
                                          :title='$t("src.views.apps.haberler.tanimlama.durum")'>
                            <el-row>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" v-on:click="popupGuncelle('popupForm')"
                                        class="onayBtn"
                                        type="primary">
                                    {{$t('src.views.apps.haberler.guncelleme.haberGuncelle')}}
                                </el-button>
                                <el-button
                                        style="margin-bottom: 10px"
                                        size="mini" @click="$router.go(-1)"
                                        class="onayBtn">
                                    Vazgeç
                                </el-button>
                            </el-row>
                        </el-collapse-item>
                        <draggable class="list-group" group="a">
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.popup.tanimlama.gorunum")' name="2">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="gorunum">
                                            <el-switch
                                                    v-model="popupForm.gorunum"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Tüm Sayfalar"
                                                    inactive-text="Anasayfa">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.popup.tanimlama.gorunumAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                            <el-collapse-item class="card-shadow--medium"
                                              :title='$t("src.views.apps.popup.tanimlama.otomatik")' name="3">
                                <el-row>
                                    <el-col :lg="24" :md="24" :sm="24" :xs="24" class="col-p">
                                        <el-form-item prop="otomatik">
                                            <el-switch
                                                    v-model="popupForm.otomatik"
                                                    active-value="1"
                                                    inactive-value="0"
                                                    active-text="Otomatik"
                                                    inactive-text="Manuel">
                                            </el-switch>
                                        </el-form-item>
                                        <div style="font-style: italic">
                                            {{$t("src.views.apps.popup.tanimlama.otomatikAciklama")}}
                                        </div>
                                    </el-col>
                                </el-row>
                            </el-collapse-item>
                        </draggable>
                    </el-collapse>
                </el-col>
            </el-form>
        </el-row>
    </div>
</template>
<script>
    import JQuery from 'jquery';
    import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

    let $ = JQuery;
    import popupService from '../../../WSProvider/PopService'
    import notification from '../../../notification'
    import draggable from 'vuedraggable'

    let base64 = require('base64_js');
    let userDataSidas = "";
    export default {
        name: "PopDuzenle",
        components: {
            draggable,
        },
        mounted() {
            this.updatePopKodu = this.$store.state.updateKodu;
            this.getPopDetay(this.updatePopKodu);
        },
        data() {
            return {
                editor: ClassicEditor,
                editorConfig: {
                    language: 'tr'
                },
                imageMain: [],
                updatePopKodu: '',
                popDetayKlon: [],
                updateData: [],
                updateDataEN: [],
                updateDataTarih: [],
                visibleSil: false,
                activeCollapse: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10'],
                popupForm: {
                    baslik: '',
                    icerik: '',
                    resim: '',
                    imageBase: '',
                    link: '',
                    tarih: '',
                    durum: '1',
                    gorunum: '0',
                    otomatik: '1',
                },
                rulesPopup: {
                    baslik: [{
                        required: true,
                        message: "Lütfen Başlık Giriniz",
                        trigger: 'blur'
                    }],
                    tarih: [{
                        required: true,
                        message: "Lütfen Tarih Giriniz",
                        trigger: 'blur'
                    }]
                },
            }
        },

        methods: {
            changeTarih(val) {
                this.updateDataTarih = val;
            },
            getPopDetay(popKodu) {
                popupService.popDetay(popKodu).then((response) => {
                    if (response.status === 200) {
                        this.popupForm.baslik = response.data.baslik;
                        this.popupForm.tarih = [response.data.baslamaTarihi, response.data.bitisTarihi];
                        this.popupForm.link = response.data.link;
                        if (response.data.icerik) {
                            this.popupForm.icerik = htmlDecode(response.data.icerik);
                        }
                        if (response.data.resim) {
                            $('.el-upload--picture-card').hide();
                            this.imageMain.push({
                                name: response.data.resim,
                                url: popupService.imageUrlOrta + response.data.resim
                            });
                        }
                        this.popupForm.durum = response.data.durum;
                        this.popupForm.otomatik = response.data.otomatik;
                        this.popupForm.gorunum = response.data.gorunum;
                        this.popDetayKlon = response.data;
                    } else {
                        notification.Status(response.status, this)
                    }
                })
            },

            imageUpload(file) {
                $('.el-upload--picture-card').hide();
                if (file.raw["type"] === 'image/jpg' || file.raw["type"] === 'image/jpeg' || file.raw["type"] === 'image/png') {
                    if (this.popupForm.baslik) {
                        var imgname = randomText(7) + '-' + linkTemizle(this.popupForm.baslik) + ".png";
                    } else {
                        imgname = randomText(7) + '-' + linkTemizle(file.name.split('.')[0].substring(0, 60)) + ".png";
                    }
                    this.popupForm.resim = imgname;
                    const files = file.raw;
                    if (files) {
                        const reader = new FileReader();
                        reader.onload = e => {
                            this.popupForm.imageBase = e.target.result;
                        };
                        reader.readAsDataURL(files);
                    }
                } else {
                    notification.Status('warning', this, 'Yalnızca ".jpeg", ".jpg" ve ".png" uzantılı görsel seçiniz!!');
                }
            },
            imageRemove(file) {
                $('.el-upload--picture-card').show();
            },
            popupGuncelle(formName) {
                for (var key in this.popDetayKlon) {
                    if (key !== 'resim' && key !== 'tarih') {
                        if (this.popDetayKlon[key] !== this.popupForm[key]) {
                            if (this.popupForm[key]) {
                                var item = {
                                    type: key,
                                    value: this.popupForm[key]
                                };
                                this.updateData.push(item);
                            }
                        }
                    } else if (key === 'resim') {
                        if (this.popDetayKlon[key] !== this.popupForm[key]) {
                            if (this.popupForm[key]) {
                                var itemImg = {
                                    type: "resim",
                                    value: this.popupForm.resim,
                                    resimBase: this.popupForm.imageBase

                                };
                                this.updateData.push(itemImg);
                            }
                        }
                    }
                }
                if (this.updateDataTarih.length > 0) {
                    item = {
                        type: "baslamaTarihi",
                        value: this.updateDataTarih[0]
                    };
                    this.updateData.push(item);
                    item = {
                        type: "bitisTarihi",
                        value: this.updateDataTarih[1]
                    };
                    this.updateData.push(item);
                }
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        if (valid && this.updateData.length !== 0) {
                            popupService.popGuncelle(this.updatePopKodu, this.updateData).then((response) => {
                                if (response.status === 200) {
                                    notification.Status('success', this, 'Pop-Up başarıyla guncellendi.');
                                    this.resetForm(formName)
                                } else if (response.status === 230) {
                                    notification.Status('warning', this, 'Bu bilgiler ile kayıtlı bir Pop-Up zaten mevcut');
                                } else {
                                    notification.Status(response.status, this)
                                }
                            })
                        } else
                            notification.Status('warning', this, 'Değişiklik yapılmadı!');
                    }
                })
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
                this.visibleSil = false;
                let tabs = this.$store.state.tabList;
                if (tabs.length === 1) {
                    $(".horizontal-nav.pos-top").removeClass("shadowBox");
                }
                var obj = tabs.find(data => data.name === "PopupDuzenle");
                if (obj !== undefined) {
                    tabs.forEach((tab, index) => {
                        if (tab.name === "PopupDuzenle") {
                            this.$store.state.tabList.splice(index, 1);
                            if (tabs[index]) {
                                this.$store.commit('changeActiveTabs', tabs[index].name);
                            } else {
                                this.$store.commit('changeActiveTabs', tabs[index - 1].name);
                            }
                        }
                    });
                }
            },

        }

    }
    function linkTemizle(text) {
        var trMap = {
            'çÇ': 'c',
            'ğĞ': 'g',
            'şŞ': 's',
            'üÜ': 'u',
            'ıİ': 'i',
            'öÖ': 'o'
        };
        for (var key in trMap) {
            text = text.replace(new RegExp('[' + key + ']', 'g'), trMap[key]);
        }
        return text.replace(/[^-a-zA-Z0-9\s]+/ig, '')
            .replace(/\s/gi, "-")
            .replace(/[-]+/gi, "-")

    }
    function htmlDecode(input) {
        var e = document.createElement('div');
        e.innerHTML = input;
        return e.childNodes[0].nodeValue;
    }

    function randomText(length) {
        let today = new Date();
        let day = today.getDate();
        let mounth = (today.getMonth() + 1);
        let year = today.getFullYear();
        let bugun = year + '' + (mounth <= 9 ? '0' + mounth : mounth) + '' + (day <= 9 ? '0' + day : day);

        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < length; i++)
            text += possible.charAt(Math.floor(Math.random() * possible.length));

        return bugun + "-" + text;
    }
</script>

<style scoped>
    .upload-demo ul {
        margin: 0;
        padding: 0;
        list-style: none;
        background: aliceblue;
        width: 50%;
    }

    .cop {
        color: #ec205f;
        position: relative;
        float: right;
        right: 15px;
        bottom: 10px;
        font-size: 20px;
    }


    .el-tag + .el-tag {
        margin-left: 10px;
    }


</style>